"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
function TabsOverflowButton(props) {
    const { count, className, onClick } = props;
    return ((0, jsx_runtime_1.jsx)(Container, { className: className, children: (0, jsx_runtime_1.jsxs)(Button, { onClick: onClick, children: [(0, jsx_runtime_1.jsx)(OverflowIcon, { name: ui_1.Icons.Tabs_Overflow }), (0, jsx_runtime_1.jsx)(Badge, { children: count })] }) }));
}
exports.default = TabsOverflowButton;
const Container = styled_components_1.default.div `
  width: 50px;
  height: 100%;
`;
const Button = (0, styled_components_1.default)(ui_1.BaseButton) `
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;

  border-right: ${props => props.theme.tabs.overflow.border};
  border-left: ${props => props.theme.tabs.overflow.border};
`;
const OverflowIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 30px;
  height: 30px;
  margin: auto;

  color: ${props => props.theme.gray2};
`;
const Badge = styled_components_1.default.div `
  position: absolute;
  top: 3px;
  right: 6px;

  display: flex;
  align-items: center;
  justify-content: center;

  box-sizing: border-box;
  width: 16px;
  height: 16px;
  padding: 1px;

  color: white;
  font-size: 10px;

  background: #2eb2ab;
  border-radius: 50%;
`;
